'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/person/Checked.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CheckedPerson = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps(__spreadValues({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8 1.33203C6.34315 1.33203 5 2.67518 5 4.33203C5 5.98889 6.34315 7.33203 8 7.33203C9.65685 7.33203 11 5.98889 11 4.33203C11 2.67518 9.65685 1.33203 8 1.33203Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.7726 9.79574C10.819 8.88856 9.52263 8.33203 8 8.33203C4.92277 8.33203 2.76982 10.6051 2.5022 13.4519C2.48902 13.592 2.53552 13.7312 2.63027 13.8353C2.72502 13.9394 2.85925 13.9987 3 13.9987H9.46675L8.93342 13.5987C8.27068 13.1016 8.13637 12.1614 8.63342 11.4987C9.13048 10.836 10.0707 10.7016 10.7334 11.1987L10.8695 11.3008L11.7726 9.79574Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.9288 10.0893C14.0709 9.85248 13.9941 9.54535 13.7573 9.40328C13.5205 9.26121 13.2134 9.33799 13.0713 9.57478L11.1565 12.7661L10.1334 11.9987C9.91245 11.833 9.59905 11.8778 9.43336 12.0987C9.26768 12.3196 9.31245 12.633 9.53336 12.7987L11 13.8987C11.1133 13.9836 11.2572 14.0166 11.3961 13.9894C11.5351 13.9622 11.6559 13.8773 11.7288 13.7559L13.9288 10.0893Z",
          fill: "currentColor"
        }
      )
    ]
  })
);

// src/person/Multiple.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var MultiplePersonIcon = (props) => {
  return /* @__PURE__ */ jsx2(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx2(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99997 5C6.89541 5 5.99997 5.89543 5.99997 7C5.99997 8.10457 6.89541 9 7.99997 9C9.10454 9 9.99998 8.10457 9.99998 7C9.99998 5.89543 9.10454 5 7.99997 5ZM3.99997 7C3.99997 4.79086 5.79084 3 7.99997 3C10.2091 3 12 4.79086 12 7C12 9.20914 10.2091 11 7.99997 11C5.79084 11 3.99997 9.20914 3.99997 7ZM17 6C16.1715 6 15.5 6.67157 15.5 7.5C15.5 8.32843 16.1715 9 17 9C17.8284 9 18.5 8.32843 18.5 7.5C18.5 6.67157 17.8284 6 17 6ZM13.5 7.5C13.5 5.567 15.067 4 17 4C18.933 4 20.5 5.567 20.5 7.5C20.5 9.433 18.933 11 17 11C15.067 11 13.5 9.433 13.5 7.5ZM18.9682 14.6066C17.886 13.884 16.5717 13.8094 15.4456 14.3698L14.5546 12.5792C16.3248 11.6984 18.4026 11.8241 20.0788 12.9433C21.7623 14.0674 22.9452 16.12 23.1432 18.9297L23.2187 20H17.0001V18H21.0075C20.6719 16.3042 19.8665 15.2064 18.9682 14.6066ZM3.12658 19H12.8734C12.2633 15.5047 10.0063 14 7.99997 14C5.99363 14 3.73669 15.5047 3.12658 19ZM7.99997 12C11.4706 12 14.6399 14.8568 14.9975 19.9297L15.0729 21H0.927002L1.00245 19.9297C1.36004 14.8568 4.5293 12 7.99997 12Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/person/PersonInFrameIcon.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var PersonInFrameIcon = (props) => /* @__PURE__ */ jsx3(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx3(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 4H22V20H2V4ZM4 6V18H7.17848C7.76766 15.9657 9.60506 14.5 12 14.5C14.3949 14.5 16.2323 15.9657 16.8215 18H20V6H4ZM14.6742 18C14.1995 17.1137 13.2597 16.5 12 16.5C10.7403 16.5 9.80048 17.1137 9.32582 18H14.6742ZM16.6762 7.60978C16.7334 7.51372 16.8039 7.42462 16.8869 7.34553C16.9527 7.28268 17.0245 7.2279 17.1008 7.18161C17.2031 7.11936 17.315 7.07137 17.4337 7.0404C17.5408 7.01234 17.6498 6.99908 17.758 6.99987C17.8649 7.00044 17.9724 7.01475 18.0779 7.04349C18.1798 7.07113 18.2766 7.11134 18.3664 7.16235C18.4597 7.21508 18.5467 7.28014 18.6249 7.35682C18.715 7.44494 18.7899 7.54504 18.8485 7.65302C18.8907 7.73044 18.9249 7.81282 18.9501 7.89905C18.982 8.0079 18.9984 8.11911 19.0001 8.22972C19.0024 8.36428 18.983 8.50027 18.9405 8.63234C18.9149 8.71191 18.8816 8.78801 18.8415 8.85975C18.7908 8.95072 18.7284 9.03591 18.655 9.11284C18.539 9.23462 18.4016 9.32948 18.2522 9.39486M16.6762 7.60978C16.6075 7.72469 16.5568 7.85155 16.5278 7.98649C16.5105 8.06703 16.5013 8.14842 16.5 8.22948C16.4982 8.33478 16.5097 8.44097 16.5351 8.54546C16.566 8.67296 16.6165 8.79283 16.6831 8.9017C16.7317 8.98151 16.7897 9.05638 16.8564 9.12452C16.9345 9.20441 17.022 9.27234 17.116 9.32756C17.2142 9.38544 17.3209 9.43029 17.4339 9.45974C17.541 9.4878 17.6501 9.50105 17.7584 9.50023C17.8662 9.49961 17.9747 9.48502 18.0811 9.45573C18.2229 9.41687 18.3547 9.35365 18.4716 9.27085M12 9.5C11.3096 9.5 10.75 10.0596 10.75 10.75C10.75 11.4404 11.3096 12 12 12C12.6904 12 13.25 11.4404 13.25 10.75C13.25 10.0596 12.6904 9.5 12 9.5ZM8.75 10.75C8.75 8.95507 10.2051 7.5 12 7.5C13.7949 7.5 15.25 8.95507 15.25 10.75C15.25 12.5449 13.7949 14 12 14C10.2051 14 8.75 12.5449 8.75 10.75Z",
        fill: "currentColor"
      }
    )
  })
);

// src/person/Rounded.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var PersonRoundedIcon = (props) => {
  return /* @__PURE__ */ jsx4(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx4(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 14.2369 4.36336 16.2715 5.77673 17.7898C7.24771 16.0739 9.41739 15 12 15C14.5826 15 16.7523 16.0739 18.2233 17.7898C19.6366 16.2715 20.5 14.2369 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM17.1085 18.7943C15.917 17.3883 14.1507 16.5 12 16.5C9.84927 16.5 8.08297 17.3883 6.89147 18.7943C8.31373 19.8655 10.0821 20.5 12 20.5C13.9179 20.5 15.6863 19.8655 17.1085 18.7943ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.9741 20.7007 17.6456 18.6413 19.4763C16.8757 21.0458 14.5484 22 12 22C9.45163 22 7.12431 21.0458 5.35869 19.4763C3.29925 17.6456 2 14.9741 2 12ZM12 7.5C10.6193 7.5 9.5 8.61929 9.5 10C9.5 11.3807 10.6193 12.5 12 12.5C13.3807 12.5 14.5 11.3807 14.5 10C14.5 8.61929 13.3807 7.5 12 7.5ZM8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/person/Single.tsx
import { jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
var SinglePerson = (props) => /* @__PURE__ */ jsxs2(
  "svg",
  __spreadProps(__spreadValues({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx5(
        "path",
        {
          d: "M8.00065 7.33333C6.52789 7.33333 5.33398 6.13943 5.33398 4.66667C5.33398 3.19391 6.52789 2 8.00065 2C9.47341 2 10.6673 3.19391 10.6673 4.66667C10.6673 6.13943 9.47341 7.33333 8.00065 7.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx5(
        "path",
        {
          d: "M2.00043 13.4662C2.25884 10.2844 4.84127 8.66675 7.98889 8.66675C11.1808 8.66675 13.8033 10.1955 13.9986 13.4667C14.0064 13.5971 13.9986 14.0001 13.4978 14.0001C11.0274 14.0001 7.35648 14.0001 2.485 14.0001C2.31781 14.0001 1.98636 13.6395 2.00043 13.4662Z",
          fill: "currentColor"
        }
      )
    ]
  })
);

// src/person/SingleOutline.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var SinglePersonOutline = (props) => /* @__PURE__ */ jsx6(
  "svg",
  __spreadProps(__spreadValues({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx6(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 2.91675C8.61929 2.91675 7.5 4.03604 7.5 5.41675C7.5 6.79746 8.61929 7.91675 10 7.91675C11.3807 7.91675 12.5 6.79746 12.5 5.41675C12.5 4.03604 11.3807 2.91675 10 2.91675ZM6.25 5.41675C6.25 3.34568 7.92893 1.66675 10 1.66675C12.0711 1.66675 13.75 3.34568 13.75 5.41675C13.75 7.48782 12.0711 9.16675 10 9.16675C7.92893 9.16675 6.25 7.48782 6.25 5.41675ZM4.47243 16.2501H15.5276C14.9974 13.6091 12.8927 11.6667 10 11.6667C7.10726 11.6667 5.0026 13.6091 4.47243 16.2501ZM3.12775 16.8166C3.46227 13.2581 6.15343 10.4167 10 10.4167C13.8466 10.4167 16.5377 13.2581 16.8723 16.8166C16.8887 16.9917 16.8306 17.1657 16.7122 17.2958C16.5937 17.4259 16.4259 17.5001 16.25 17.5001H3.75C3.57407 17.5001 3.40628 17.4259 3.28784 17.2958C3.1694 17.1657 3.11128 16.9917 3.12775 16.8166Z",
        fill: "currentColor"
      }
    )
  })
);

export {
  CheckedPerson,
  MultiplePersonIcon,
  PersonInFrameIcon,
  PersonRoundedIcon,
  SinglePerson,
  SinglePersonOutline
};
//# sourceMappingURL=chunk-TBLHLSSA.mjs.map